module.exports = __webpack_public_path__ + "img/2b00459.jpg";